import { useEffect, useState } from "react";
import styled from "styled-components";
import DateOption1 from "../Components/DateOption1";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import { showToast } from "../Utils/variables";
import AlarmApplyBox from "./AlarmApply";

const DonationApplyBox = ({
  handleClickX,
  handleApply,
  handleEdit,
  isEditing,
  _startTime,
  _endTime,
}) => {
  const [startTime, setStartTime] = useState(_startTime);
  const [endTime, setEndTime] = useState(_endTime);

  const [clickApply, setClickApply] = useState(false);

  useEffect(() => {
    setStartTime(_startTime);
    setEndTime(_endTime);
  }, []);

  const handleOpenApplyModal = () => {
    if (startTime?.getTime() > endTime?.getTime()) {
      showToast("시작일은 종료일보다 늦을 수 없습니다.", "error");
      return;
    }

    setClickApply(true);
  };

  return (
    <div>
      {clickApply && (
        <AlarmApplyBox
          title={
            isEditing
              ? "기부 발걸음을 수정하시겠습니까?"
              : "기부 발걸음을 등록하시겠습니까?"
          }
          handleClickX={() => setClickApply(false)}
          handleApply={() =>
            isEditing
              ? handleEdit(startTime, endTime)
              : handleApply(startTime, endTime)
          }
        />
      )}
      <Box>
        <div className="hrz-wrapper center">
          <p className="bold-text" style={{ fontSize: "24px" }}>
            누적 기부 발걸음
          </p>
        </div>
        <div className="hrz-wrapper" style={{ marginTop: "-32px" }}>
          <div style={{ marginLeft: "auto", cursor: "pointer" }}>
            <IconCrossRound onClick={handleClickX} />
          </div>
        </div>

        <div className="center">
          <div style={{ width: "370px", marginTop: "10px" }}>
            <p style={{ wordBreak: "break-word", textAlign: "center" }}>
              등록 시 앱 내 기업모드에 ‘홈{">"}만보기{">"}전체’ 탭 ‘우리기업
              누적 기부 발걸음’에 반영됩니다.
            </p>
          </div>
        </div>

        <OptionBox>
          <p className="medium-text" style={{ color: "#888888" }}>
            발걸음 집계 기간*
          </p>
          <div style={{ height: "14px" }} />
          <DateOption1
            startTitle="시작일"
            endTitle="종료일"
            width="186px"
            gap="8px"
            startDate={startTime}
            endDate={endTime}
            setStartDate={setStartTime}
            setEndDate={setEndTime}
          />
        </OptionBox>

        <div className="info-text">
          <p>· 누적 발걸음 기준 : 전체 구성원의 누적 만보기 걸음 수.</p>
          <p>
            · 오늘 날짜로 기간 설정 시 등록 즉시 걸음 수 집계가 시작됩니다.{" "}
          </p>
          <p>
            · 오늘 날짜 이후로 기간 설정 시 해당 날짜의 00:00 에 집계가 시작되며
            23:59 에 종료
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;됩니다.
          </p>
        </div>

        <div
          className="blueBtn-base"
          style={{
            width: "500px",
            height: "60px",
            borderRadius: "10px",
            marginTop: "30px",
          }}
          onClick={handleOpenApplyModal}
        >
          {isEditing ? "수정" : "등록"}
        </div>
      </Box>
    </div>
  );
};

const Box = styled.div`
  width: auto;
  height: auto;
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  .info-text {
    margin-top: 14px;
    > p {
      font-size: 14px;
      color: #888888;
    }
  }
`;

const OptionBox = styled.div`
  border-radius: 20px;
  padding: 20px;
  background-color: #f5f5f5;
  margin-top: 30px;
`;

const DonationApply = ({
  handleClickX,
  handleApply,
  handleEdit,
  isEditing = false,
  startTime = new Date(),
  endTime = new Date(),
}) => {
  return (
    <LayoutModal
      Modal={
        <DonationApplyBox
          handleClickX={handleClickX}
          isEditing={isEditing}
          handleApply={handleApply}
          handleEdit={handleEdit}
          _startTime={startTime}
          _endTime={endTime}
        />
      }
    />
  );
};

export default DonationApply;
